import {toast} from 'react-hot-toast';
import {Box, IconButton, Typography} from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';

const duration = 10000; // 10 วิ
export default async function BaseAlert(type, title, message, path) {
    const toastType = getTypeForToast(type);
    if (toastType === 'info') {
        await new Promise((resolve) => {
            return toast((t) =>
                    <Box
                        sx={{
                            textAlign: 'start',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            color: "#000000",
                        }}
                    >
                        <Box>
                            <Typography variant={'subtitle1'} fontWeight={'bolder'}>{title}</Typography>
                            <Typography variant={'body1'}>{message}</Typography>
                        </Box>
                        <Box textAlign={'right'}>
                            <IconButton aria-label="dismiss" onClick={() => {
                                toast.dismiss(t.id);
                                resolve();
                            }}>
                                <CancelIcon/>
                            </IconButton>
                        </Box>
                    </Box>,
                {
                    title,
                    // duration: Infinity,
                    duration: duration,
                    onClosed: resolve,
                    style: {
                        borderRadius: '10px',
                        border: '1px rgba(107,66,187,0.29) solid',
                        background: 'rgba(196,191,191,0.7)',
                        "&:hover": {
                            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px"
                        },
                    },
                }
            );
        })
    } else {
        await new Promise((resolve) => {
            const toastId = toast[toastType]( // เรียกใช้ฟังก์ชันตาม toastType ที่กำหนดไว้ใน getTypeForToast
                <Box
                    sx={{
                        textAlign: 'start',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',

                    }}
                >
                    <Box>
                        <b>{message}</b>
                    </Box>
                    <Box textAlign={'right'}>
                        <IconButton aria-label="dismiss" onClick={() => {
                            toast.dismiss(toastId);
                            resolve();
                        }}>
                            <CancelIcon/>
                        </IconButton>
                    </Box>
                </Box>,
                {
                    title,
                    // duration: Infinity,
                    duration: duration,
                    onClosed: resolve,
                    style: {
                        color: `${toastType}`,
                        borderRadius: '10px',
                        border: '1px rgba(107,66,187,0.29) solid',
                        background: 'rgba(196,191,191,0.7)',
                        "&:hover": {
                            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px"
                        },
                    },
                }
            );
        });
    }
}

function getTypeForToast(type) {
    switch (type) {
        case 'success':
            return 'success';
        case 'error':
            return 'error';
        case 'loading':
            return 'loading';
        default:
            return 'info';
    }
}
